import { render, staticRenderFns } from "./DeliveryPerformanceCountryWise.vue?vue&type=template&id=072d83ab"
import script from "./DeliveryPerformanceCountryWise.vue?vue&type=script&lang=js"
export * from "./DeliveryPerformanceCountryWise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports